import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { PostData } from "../../post.models";
import {
  CommentList,
  CommentText,
  DisabledCommentListItem,
} from "./comment-viewer.component.styles";
import "./comment-viewer.component.styles.ts";

export interface CommentViewerProps extends PostData {}

export function CommentViewer(props: CommentViewerProps) {
  const numComments = props.comments?.length ?? 0;

  if (
    numComments == 0 &&
    (props.contentType == "video" || props.contentType == "advertisement")
  ) {
    return (
      <div className={`${props.id}-comment-viewer`}>
        <Box sx={DisabledCommentListItem}>
          Comments are disabled for this post.
        </Box>
      </div>
    );
  }

  return (
    <List sx={CommentList} id={`${props.id}-comment-viewer`}>
      {props.comments?.map((comment) => {
        return (
          <ListItem
            key={`${comment.id}-${Math.random().toString(16).slice(8)}`}
            id={`${props.id}-comment-${comment.id}`}
          >
            <ListItemAvatar id={`${props.id}-comment-${comment.id}-avatar`}>
              <Avatar
                src={comment.avatar}
                alt={comment.author}
                id={`${props.id}-comment-${comment.id}-avatar`}
              />
            </ListItemAvatar>
            <ListItemText
              primary={comment.body}
              id={`${props.id}-comment-${comment.id}-text`}
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ color: "text.primary", display: "inline" }}
                    visibility={comment.author != null ? "visible" : "hidden"}
                    id={`${props.id}-comment-${comment.id}-author`}
                  >
                    {comment.author}
                  </Typography>
                  {" -- "}
                  {comment.date}
                </React.Fragment>
              }
              sx={CommentText}
            />
          </ListItem>
        );
      })}
    </List>
  );
}
